module.exports = __webpack_public_path__ + "static/media/ship-bg-mobile-star.f31c6b77.jpg";